import { AnalyticsBankLinkEvent } from '@/shared/lib/analytics'
import { BankName } from '@/shared/api/rest/types'

export const banks: Bank[] = [
    {
        id: BankName.NAMBA_ONE,
        logo: 'namba',
        name: 'Namba One',
        link:
            window.location.origin === 'https://pay-dev.namba.kg'
                ? 'https://pay-dev.namba.kg/'
                : 'https://nambaone.app/',
        eventName: 'Click On Namba One',
        googlePlayId: 'namba.wallet.nambaone',
    },
    // {
    //     logo: 'elcart',
    //     id: BankName.ELCART,
    //     name: 'Элкарт Мобайл',
    //     link: 'https://pay.payqr.kg/',
    // },
    {
        id: BankName.MBANK,
        logo: 'mbank',
        name: 'МБанк',
        link: 'https://app.mbank.kg/qr/',
        eventName: 'Click On Mbank',
        googlePlayId: 'com.maanavan.mb_kyrgyzstan',
    },
    // {
    //     id: BankName.RSK_24,
    //     logo: 'rsk24',
    //     name: 'RSK24',
    //     link: '',
    // },
    {
        id: BankName.DEMIR_BANK,
        logo: 'demirbank',
        name: 'DemirBank',
        link: 'https://retail.demirbank.kg/',
        eventName: 'Click On Demir Bank',
        googlePlayId: 'kg.demirbank.mobileib.v3',
    },
    // {
    //     id: BankName.ELCOM,
    //     logo: 'elcom',
    //     name: 'Элсом',
    //     link: '',
    // },
    {
        id: BankName.BAKAI,
        logo: 'bakai',
        name: 'BakAi',
        link: 'https://bakai.app',
        eventName: 'Click On Bakai',
        googlePlayId: 'kg.bta.mobilebank2',
    },
    // {
    //     id: BankName.KOMPANION,
    //     logo: 'kompanion',
    //     name: 'Kompanion',
    //     link: 'https://pay.payqr.kg/',
    // },
    {
        id: BankName.AIYL,
        logo: 'ail',
        name: 'Айыл',
        link: 'https://qr.ab.kg',
        eventName: 'Click On Aiyl',
        googlePlayId: 'app.ab.banking',
    },
    // {
    //     id: BankName.FINCA,
    //     logo: 'finca',
    //     name: 'Finca ',
    //     link: '',
    // },
    // {
    //     id: BankName.BALANCE,
    //     logo: 'balance',
    //     name: 'Balance.kg ',
    //     link: 'https://balance.kg/',
    // },
    // {
    //     id: BankName.KKB,
    //     logo: 'kkb',
    //     name: 'KKB ',
    //     link: 'https://pay.payqr.kg/',
    // },
    // {
    //     id: BankName.KSB,
    //     logo: 'ksb',
    //     name: 'KSB',
    //     link: '',
    // },
    {
        id: BankName.MEGAPAY,
        logo: 'megapay',
        name: 'MegaPay ',
        link: 'https://megapay.kg/get/',
        eventName: 'Click On Megapay',
        googlePlayId: 'com.kp.megapay.kg',
    },
    // {
    //     id: BankName.MBULAK,
    //     logo: 'mbulak',
    //     name: 'М Булак',
    //     link: '',
    // },
    {
        id: BankName.ODENGI,
        logo: 'о',
        name: 'О! Деньги',
        link: 'https://api.dengi.o.kg/',
        eventName: 'Click On Odengi',
        googlePlayId: 'kg.o.nurtelecom',
    },
    {
        id: BankName.SIMBA,
        logo: 'simba',
        name: 'Simbank',
        link: 'https://simbank.kg/scan_to_pay?payload=https://app.mbank.kg/qr/',
        eventName: 'Click On Simbank',
        googlePlayId: 'com.doscredo.simbank',
    },
    {
        id: BankName.KOMPANION,
        logo: 'kompanion',
        name: 'Kompanion',
        link: 'https://24.kompanion.kg/qr/',
        eventName: 'Click On Kompanion',
        googlePlayId: 'com.kp.kompanion',
    },
    {
        id: BankName.ELDIK,
        logo: 'eldik',
        name: 'Элдик',
        link: 'https://pay.payqr.kg/',
        eventName: 'Click On Eldik',
        googlePlayId: 'kg.rsk.staging',
    },
    {
        id: BankName.KICB,
        logo: 'kicb',
        name: 'KICB',
        link: 'https://bank.kicb.net/',
        eventName: 'Click On KICB',
        googlePlayId: 'net.kicb.ibankprod',
    },
    {
        id: BankName.OPTIMA,
        logo: 'optima',
        name: 'Optima24',
        link: 'https://mobile.optima24.kg/my-qr/confirm-screen?qr-url=',
        eventName: 'Click On Optima',
        googlePlayId: 'kz.optimabank.optima24',
    },
]

export type Bank = {
    id: BankName
    logo: string
    name: string
    link: string
    eventName?: AnalyticsBankLinkEvent['name']
    googlePlayId: string
}
